import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, salesman: null });
  const [settings, setSettings] = useState(null);

  const refreshSettings = useCallback(async () => {
    const s = await api.get("/settings");
    setSettings(s.data);
  }, []);

  const loadMe = useCallback(async () => {
    if (!localStorage.getItem("sims_token")) return setState({ loading: false, user: null, salesman: null });
    try {
      const r = await api.get("/auth/me");
      await refreshSettings();
      setState({ loading: false, user: r.data.user, salesman: r.data.salesman });
    } catch {
      localStorage.removeItem("sims_token");
      setState({ loading: false, user: null, salesman: null });
    }
  }, [refreshSettings]);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (username, password) => {
    const r = await api.post("/auth/login", { username, password });
    localStorage.setItem("sims_token", r.data.token);
    await loadMe();
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("sims_token");
    setState({ loading: false, user: null, salesman: null });
  };

  return (
    <Ctx.Provider value={{ ...state, settings, bizDate: settings?.business_date, login, logout, refreshSettings }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
